import { Injectable } from "@angular/core";
import { Destructable } from "@models/index";
import { debug } from "@helpers/debug";

@Injectable({
	providedIn: "root"
})
export class DestructorService {
	private services: Destructable[];

	public constructor() {
		this.services = [];
	}

	public clean(): void {
		this.services.forEach((d: Destructable) => {
			d.destroy();
			if (debug) {
				console.log("[killed service]", d.name);
			}
		});
	}

	public register(service: Destructable, alternativeName = null): void {
		if (alternativeName != null) {
			service.name = alternativeName;
		}
		console.info("registered:", service.name);
		this.services.push(service);
	}

	public getServiceByName(n: string): Destructable {
		return this.services.find((s) => s.name === n);
	}
}
